import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { authReducer, AuthState } from './reducers/auth.reducer';
export interface State {
  auth: AuthState;
}

export const reducers: ActionReducerMap<State> = {
  auth: authReducer,
};

export const metaReducers: MetaReducer<State>[] = [];
